import { render, staticRenderFns } from "./custom-quick-search-card.vue?vue&type=template&id=636335e5&scoped=true"
import script from "./custom-quick-search-card.vue?vue&type=script&lang=js"
export * from "./custom-quick-search-card.vue?vue&type=script&lang=js"
import style0 from "./custom-quick-search-card.vue?vue&type=style&index=0&id=636335e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636335e5",
  null
  
)

export default component.exports